import React from "react";
import { css } from "@emotion/react";
import { FieldLabel } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { requiredKanaNameValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  nameLastName: string;
  nameFirstName: string;
};

const kanaNameFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <FieldLabel isRequired>氏名(カナ)</FieldLabel>
      </div>
      <div css={inputWrapper}>
        <div css={textFieldWrapper}>
          <FormTextField
            name={props.nameLastName}
            placeholder="例) タナカ"
            registerOptions={{
              validate: requiredKanaNameValidation,
            }}
            ref={ref}
            css={textField}
          />
          <FormErrorMessage name={props.nameLastName} css={errorField} />
        </div>
        <div css={textFieldWrapper}>
          <FormTextField
            name={props.nameFirstName}
            placeholder="例) タロウ"
            registerOptions={{
              validate: requiredKanaNameValidation,
            }}
            ref={ref}
            css={textField}
          />
          <FormErrorMessage name={props.nameFirstName} css={errorField} />
        </div>
      </div>
    </div>
  );
};

export const KanaNameFormField = React.forwardRef(kanaNameFormField);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const textField = css({
  display: "inline-block",
});

const textFieldWrapper = css({
  width: "49%",
});

const inputWrapper = css({
  width: "100%",
  display: "flex",
  flex: 1,
  justifyContent: "space-between",
});

const errorField = css({
  display: "inline-block",
});
